// TODO: Port from Next.js app

interface JourneyTimelineSkeletonProps {
  eventCount: number;
}

export function JourneyTimelineSkeleton(props: JourneyTimelineSkeletonProps) {
  return <div>JourneyTimelineSkeleton placeholder</div>;
}

interface FunnelChartSkeletonProps {
  stageCount: number;
}

export function FunnelChartSkeleton(props: FunnelChartSkeletonProps) {
  return <div>FunnelChartSkeleton placeholder</div>;
}
